import { createNamedOptionChoice, fetchNamedOptionChoices } from "features/settings/api/namedOptionResource";
import { outreachAssigneeResource } from "features/settings/constants/healthSelectionResources";

export const fetchOutreachAssignees = async (search: string) => {
  return fetchNamedOptionChoices(outreachAssigneeResource, search);
};

export const createOutreachAssignee = async (name: string) => {
  return createNamedOptionChoice(outreachAssigneeResource, name);
};
